import { FC } from "react";

export interface AvatarProps {
  containerClassName?: string;
  sizeClass?: string;
  radius?: string;
  imgUrl?: string;
  userName?: string;
  hasChecked?: boolean;
  hasCheckedClass?: string;
  changePictureIcon?: boolean;
  onChangePicture?: () => void;
}

const Avatar: FC<AvatarProps> = ({
  containerClassName = "ring-1 ring-white dark:ring-neutral-900",
  sizeClass = "h-6 w-6 text-sm",
  radius = "rounded-full",
  imgUrl = "https://www.hotelnicolaas.nl/images/joomlart/demo/default.jpg",
  userName,
  hasChecked,
  hasCheckedClass = "w-4 h-4 -top-0.5 -right-0.5",
  changePictureIcon = false,
  onChangePicture = () => {},
}) => {
  const url = imgUrl || "https://www.hotelnicolaas.nl/images/joomlart/demo/default.jpg";
  const name = userName || "John Doe";

  return (
    <div
      className={`wil-avatar relative flex-shrink-0 inline-flex items-center justify-center text-neutral-100 uppercase font-semibold shadow-inner ${radius} ${sizeClass} ${containerClassName}`}
      style={{ backgroundColor: url ? undefined : "#ff4c4c" }}
    >
      {url && (
        <img
          className={`absolute inset-0 w-full h-full object-cover ${radius}`}
          src={url}
          alt={name}
        />
      )}
      <span className="wil-avatar__name">{name[0]}</span>

      {hasChecked && (
        <span
          className={`bg-teal-500 rounded-full text-white text-xs flex items-center justify-center absolute  ${hasCheckedClass}`}
        >
          <i className="las la-check"></i>
        </span>
      )}

      {changePictureIcon && (
        <div className="bg-white border border-red-500 rounded-full flex items-center justify-center absolute right-0 bottom-0 w-8 h-8" onClick={onChangePicture}>
          <i className="las la-camera text-red-500 text-md"></i>
        </div>
      )}
    </div>
  );
};

export default Avatar;
